import React from "react";
import { CircularProgress, Box } from "@mui/material";

const LoadingSpinner = () => {
  return (
    <Box
      display="flex"
      flex={1}
      justifyContent="center"
      alignItems="center"
      height="100%" // Adjust as needed
      width="100%"
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingSpinner;
